import React from "react";
import crispinProfile from "../../../../assets/crispin_profile.png";

export default function BeyondTheStack() {
  return (
    <section className="bg-brand-cream border-t border-brand-sand py-12 md:py-16">
      <div className="max-w-3xl mx-auto px-6 flex flex-col sm:flex-row gap-6 items-center sm:items-start">
        <img 
          src={crispinProfile} 
          alt="Crispin" 
          className="w-24 h-24 sm:w-28 sm:h-28 object-cover rounded-sm border border-brand-sand shadow-sm shrink-0" 
          loading="lazy"
          width={112}
          height={112}
        />
        <div className="space-y-2 text-left">
          <h2 className="text-xl font-bold font-display text-brand-charcoal tracking-tight">
            Beyond the Stack
          </h2>
          <p className="text-stone-700 font-light leading-relaxed text-sm">
            Former winery owner, sailor, and ski bum. Currently funding my wife's horse-collecting habit to ensure we remain permanently indebted to the local feed store.
          </p>
        </div>
      </div>
    </section>
  );
}
